import React from 'react';
import { IconProps } from './types';

export const UncheckedCircleIcon = (props: IconProps) => {
  const { size = 20, color = '#E0E0E0', style = {} } = props;

  return (
    <svg
      style={style}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='10' cy='10' r='9' stroke={color} strokeWidth='2' />
    </svg>
  );
};
